'use client';
import * as React from "react";
import { useTeachingPopoverCarouselPageCount_unstable } from "./useTeachingPopoverCarouselPageCount.js";
import { renderTeachingPopoverCarouselPageCount_unstable } from "./renderTeachingPopoverCarouselPageCount.js";
import { useTeachingPopoverCarouselPageCountStyles_unstable } from "./useTeachingPopoverCarouselPageCountStyles.styles.js";
import { useCustomStyleHook_unstable } from "@fluentui/react-shared-contexts";
/**
 * TeachingPopoverCarouselPageCount is a simple interface for rendering based on current and total page count
 *
 * The child render function will provide both current and total page numbers for customization.
 */ export const TeachingPopoverCarouselPageCount = /*#__PURE__*/ React.forwardRef((props, ref)=>{
    const state = useTeachingPopoverCarouselPageCount_unstable(props, ref);
    useTeachingPopoverCarouselPageCountStyles_unstable(state);
    useCustomStyleHook_unstable('useTeachingPopoverCarouselPageCountStyles_unstable')(state);
    return renderTeachingPopoverCarouselPageCount_unstable(state);
});
TeachingPopoverCarouselPageCount.displayName = 'TeachingPopoverCarouselPageCount';
